import { Component, Input } from '@angular/core';
import { Platform, NavController, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SharedService, MessageService, ErrorService, User, SessionService, ConfigService, AppType, SportBetPanelService, LottoBetpanelService } from 'baseline-lib';
import { Global } from '../global/global';
import { HomePage } from './home/home/home';
import { TranslateService } from '@ngx-translate/core';
import { App } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomToast } from './shared/services/custom-toast';
import { LoginModalPage } from './shared/login-modal/login-modal';
import { GreyPage } from './shared/grey/grey';

declare function DeviceUUID(): void;

declare function hashMD5(value);

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @Input() appType;
 
  rootPage : any = GreyPage;
  private sub : any;
  timer: any;
  private _onDestroy = new Subject<void>();
  public IsshowHome: boolean;
  
  constructor(public platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
    private _sharedService: SharedService,private _messageService: MessageService,
    private _errorService: ErrorService,private globalData : Global,
    private translate: TranslateService,public _sportsBetpanelServices : SportBetPanelService,
    public app: App, public _lottoBetpanelService : LottoBetpanelService,
    public loadingCtrl : LoadingController,public toast : CustomToast,
    private _sessionService: SessionService,private _configService: ConfigService,
    public modalCtrl : ModalController) 
  {
    
     platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleLightContent();
      splashScreen.hide();

      this.globalData._imageUrl = this._configService.getImageUrl();

      //if ((<any>window).cordova) {

      if(localStorage.getItem("loggedIn") !== null && localStorage.getItem("loggedIn") !== ""){
        this.globalData.isLoggedIn = localStorage.getItem("loggedIn").toLowerCase() == 'true' ? true : false;
      }
      else
        this.globalData.isLoggedIn = false;

      if(this.globalData.isLoggedIn){ // user is already Logged In
        if(localStorage.getItem("authUser") !== null && localStorage.getItem("authUser") !== ""){
          this.globalData.authUser = <User>JSON.parse(localStorage.getItem("authUser"));
          this._sessionService.authUser = this.globalData.authUser;
          this._sharedService.loginSubject.next(true);
        }
      }

      if((this._configService.isplayerLogin() && this._configService.getAppType() == AppType.user ) || this._configService.getAppType() == AppType.retailer){
        //let profileModal = this.modalCtrl.create(LoginModalPage);
        //profileModal.present();

        this._sharedService.loginSubject.subscribe((data) => {
          console.log("Subscriber got data >>>>> "+ data);
          if(data == false){
            this.rootPage = GreyPage;
            let profileModal = this.modalCtrl.create(LoginModalPage);
            profileModal.present();
          }else{
            this.rootPage = HomePage;          
          }
        });

      }
      else
      {
        this.rootPage = HomePage;        
      }
      // }else{
      //   localStorage.clear();
      // }
    });

    
    // language change detection
    this._sharedService.languageChange.subscribe(data => {
    // let loader = this.loadingCtrl.create({
    //   content: "Please Wait",
    // });
    // loader.present();
      if(this.translate.getDefaultLang() != data)
      {   
        this.translate.setDefaultLang(data);
        this._sharedService.selectedLanguage = data;
        //this.app.getRootNav().setRoot(HomePage); 
      }
      // loader.dismiss();
    });  
}

ngOnInit()
{ 

    // set channel type based on config
    this._configService.getChannelType();

    this.platform.resume.subscribe(()=> {
      if(this._sharedService.timerSub)
            this._sharedService.timerSub.unsubscribe();
          //Start Timer.
          this._sharedService.getTimeFromServerForClock();
    });

    this.sub = this._sharedService.userBalanceUpdateGameType.subscribe(
      res => {
        if (res) {
          this._sharedService._sessionService.updateUserBalanceGameType(res.bal, res.bal, res.wli, res);
          if(this._sessionService.authUser){
            this.globalData.authUser = this._sessionService.authUser;
            localStorage.setItem("authUser",JSON.stringify(this.globalData.authUser));
          }
        }
      }
    )
    

    this._sharedService.loginSubject.subscribe((data) => {
      console.log("Subscriber got data >>>>> "+ data);
        if (data == true) {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          if (this._sessionService.getAuthUser()) {
            this.IsshowHome = true;
            this.timer = setInterval(() => {
              var token = this._sessionService.getAuthUser().tokenNo;
              this._messageService.getPlayerBalance(token).subscribe(
                res => {
                  this._sharedService.userBalanceUpdateGameType.next(res);          
                },
                error => {
                  if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }
              )
            }, this._configService.getBalanceDuration());
          }
        }
        else {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      });

      this._sharedService.logOutEmitter.
      subscribe(data => {
        data = data == false ? undefined : data;
        if (data) {
          data = undefined;
          this.doSignOut();
        }
      });

  this.createUUid();
}

doSignOut(){
  localStorage.clear();
  this.globalData.selectedMenu = "home";
  this.globalData.isLoggedIn = false;
  this.globalData.authUser = new User();
  this._sessionService.authUser =  undefined;
  this._lottoBetpanelService.clearallBetPanels();
  this._sportsBetpanelServices.clearallBetPanels();
  this.translate.get('You have been logged out successfully!').subscribe(
    value => 
    {
      this.toast.showSuccess(value);
    });
  
  this._sharedService.logOutEmitter.next(false);
  this._sharedService.loginSubject.next(false);
  if(!this._configService.isplayerLogin())
    this.app.getRootNav().setRoot(HomePage); 
}

createUUid() {

  var du = new DeviceUUID().parse();

  var dua = [

    du.language,

    du.platform,

    du.os,

    du.cpuCores,

    du.isAuthoritative,

    du.silkAccelerated,

    du.isKindleFire,

    du.isDesktop,

    du.isMobile,

    du.isTablet,

    du.isWindows,

    du.isLinux,

    du.isLinux64,

    du.isMac,

    du.isiPad,

    du.isiPhone,

    du.isiPod,

    du.isSmartTV,

    du.pixelDepth,

    du.isTouchScreen

  ];

  var uuid = du.hashMD5(dua.join(':'));

  this._sharedService.uuid = uuid;

}

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts